import { api, API_URL } from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Fetch all gift
export const getGifts = async () => {
  try {
    const response = await api.get(`${API_URL}/gift`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};

// Add a new gift
export const addGift = async (gift) => {  
  try {
    const response = await api.post(`${API_URL}/gift`, gift,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};


// Update a gift
export const updateGift = async (id, gift) => {
  try {
    console.log(gift);
    const response = await api.put(`${API_URL}/gift/${id}`, gift ,{
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};


// Update an gift status
export const updateGiftStatus = async (id, updateGiftObj) => {
  try {
    const response = await api.put(`${API_URL}/gift/status/${id}`, updateGiftObj);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};


// Delete a gift
export const deleteGift = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/gift/${id}`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error); // Handle 401/403 errors and clear cookies
  }
};



export const getGiftList = async () => {
  try {
    const response = await api.get(`${API_URL}/gift`);
    return response.data;
  }
  catch (err) {
    handleUnauthorizedOrForbidden(err);
  }
}
